import React from 'react'
import {Redirect} from "react-router-dom"
import SignInWidget from './sign_in_widget'
import Cookies from 'js-cookie';
// import { useSelector } from 'react-redux';

function SignIn() {

  const accesTokenValue = Cookies.get('userAccessToken');
  // const loginUserEmail = Cookies.get('userEmail');
  // const loginUserName = Cookies.get('userName');
  // const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  // const user = useSelector((state) => state.auth.user);

  return (
    <div>
      { (accesTokenValue !== undefined && accesTokenValue.length >0) &&
        <Redirect to="/dashboard" />
      }
      <SignInWidget/>
    </div>
  )
}

export default SignIn